<template>
  <div class="sla-metrics">
    <!-- Card contenedora principal para SLA -->
    <div class="chart-container">
      <h5><i class="fal fa-clock text-info"></i> Métricas de Cumplimiento SLA</h5>


              <!-- Resumen de SLA -->
        <div class="row mb-4">
          <div class="col-lg-3">
            <div class="summary-item">
              <div class="summary-icon text-success">
                <i class="fal fa-check-circle fa-2x"></i>
              </div>
              <div class="summary-content">
                <div class="summary-value">{{ slaMetrics.cumplimiento_general || 0 }}%</div>
                <div class="summary-label">Cumplimiento General</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="summary-item">
              <div class="summary-icon text-warning">
                <i class="fal fa-exclamation-triangle fa-2x"></i>
              </div>
              <div class="summary-content">
                <div class="summary-value">{{ slaMetrics.solicitudes_proximas_vencer || 0 }}</div>
                <div class="summary-label">Próximas a Vencer</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="summary-item">
              <div class="summary-icon text-danger">
                <i class="fal fa-times-circle fa-2x"></i>
              </div>
              <div class="summary-content">
                <div class="summary-value">{{ slaMetrics.solicitudes_vencidas || 0 }}</div>
                <div class="summary-label">Vencidas</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="summary-item">
              <div class="summary-icon text-info">
                <i class="fal fa-clock fa-2x"></i>
              </div>
              <div class="summary-content">
                <div class="summary-value">{{ slaMetrics.tiempo_resolucion_promedio || 0 }}h</div>
                <div class="summary-label">Tiempo Promedio</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Indicadores Adicionales -->
        <div class="row mb-4">
          <div class="col-lg-4">
            <div class="summary-item">
              <div class="summary-icon text-danger">
                <i class="fal fa-flag fa-2x"></i>
              </div>
              <div class="summary-content">
                <div class="summary-value">{{ slaMetrics.cumplimiento_alta || 0 }}%</div>
                <div class="summary-label">Alta Prioridad</div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="summary-item">
              <div class="summary-icon text-warning">
                <i class="fal fa-flag fa-2x"></i>
              </div>
              <div class="summary-content">
                <div class="summary-value">{{ slaMetrics.cumplimiento_media || 0 }}%</div>
                <div class="summary-label">Media Prioridad</div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="summary-item">
              <div class="summary-icon text-success">
                <i class="fal fa-flag fa-2x"></i>
              </div>
              <div class="summary-content">
                <div class="summary-value">{{ slaMetrics.cumplimiento_baja || 0 }}%</div>
                <div class="summary-label">Baja Prioridad</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Métricas de Tiempo -->
        <div class="row mb-4">
          <div class="col-lg-4">
            <div class="summary-item">
              <div class="summary-icon text-primary">
                <i class="fal fa-stopwatch fa-2x"></i>
              </div>
              <div class="summary-content">
                <div class="summary-value">{{ slaMetrics.tiempo_resolucion_promedio || 0 }}h</div>
                <div class="summary-label">Tiempo de Resolución</div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="summary-item">
              <div class="summary-icon text-info">
                <i class="fal fa-user-clock fa-2x"></i>
              </div>
              <div class="summary-content">
                <div class="summary-value">{{ slaMetrics.tiempo_asignacion_promedio || 0 }}h</div>
                <div class="summary-label">Tiempo de Asignación</div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="summary-item">
              <div class="summary-icon text-warning">
                <i class="fal fa-level-up-alt fa-2x"></i>
              </div>
              <div class="summary-content">
                <div class="summary-value">{{ slaMetrics.tiempo_escalacion_promedio || 0 }}h</div>
                <div class="summary-label">Tiempo de Escalamiento</div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

  <script>
  export default {
    name: 'SLAMetrics',
    props: {
      slaMetrics: {
        type: Object,
        default: () => ({})
      }
    },
    methods: {
      getPriorityClass(value) {
        if (value >= 90) return 'priority-success'
        if (value >= 75) return 'priority-warning'
        return 'priority-danger'
      }
    }
  }
  </script>

  <style scoped>
  .sla-metrics {
    margin-bottom: 30px;
  }

  .sla-badge {
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 15px;
  background: #ffffff;
  transition: all 0.2s ease;
  position: relative;
}

.sla-badge:hover {
  transform: translateY(-1px);
}

  .sla-badge {
  background: #ffffff;
  color: #374151;
}

  .sla-value {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 8px;
  }

  .sla-label {
    font-size: 0.9rem;
    opacity: 0.9;
    margin-bottom: 12px;
    font-weight: 600;
    text-transform: uppercase;
  }





  .sla-time-value {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .sla-time-label {
    font-size: 0.8rem;
    opacity: 0.9;
  }

  .chart-container {
    background: white;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
  }

  .chart-container h5 {
  color: #495057;
  margin-bottom: 20px;
  font-weight: 600;
}









.summary-item {
  display: flex;
  align-items: center;
  padding: 15px;
  border-radius: 8px;
  background: #ffffff;
  margin-bottom: 15px;
  border: 1px solid #e9ecef;
}

  .summary-icon {
    margin-right: 15px;
    flex-shrink: 0;
  }

  .summary-content {
    flex-grow: 1;
  }

  .summary-value {
    font-size: 1.5rem;
    font-weight: bold;
    color: #495057;
    margin-bottom: 5px;
  }

  .summary-label {
    font-size: 0.9rem;
    color: #6c757d;
  }

  /* Responsive adjustments */
  @media (max-width: 768px) {
    .sla-value {
      font-size: 1.5rem;
    }

    .sla-time-value {
      font-size: 1.2rem;
    }

    .priority-value {
      font-size: 1.5rem;
    }

    .summary-value {
      font-size: 1.2rem;
    }
  }
  </style>
